
import { defineComponent, PropType, reactive } from 'vue'
import { SettingsContractType } from '@/new-services/types/settings-contract-types'

import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import useNotifications from '@/common/composable/useNotifications'
import useAccount from '@/common/composable/useAccount'

import { deleteSettingsContractType } from '@/new-services/settingsContractTypes.service'

export default defineComponent({
    components: { Cheap, TheButton },
    props: {
        item: {
            type: Object as PropType<SettingsContractType>,
            required: true,
        },
    },
    emits: ['deleted', 'update'],
    setup(props, { emit }) {
        const { havePermissions } = useAccount()
        const notifications = useNotifications()

        const state = reactive({
            is_deleting: false
        })

        const deleteContractType = async () => {
            if (!havePermissions(['contract-type-delete', 'all-root-permission'])) {
                return
            }

            const answer = confirm(`Вы действительно хотите удалить тип договора '${props.item.name}'?`)
            if (!answer) return

            try {
                state.is_deleting = true

                await deleteSettingsContractType(props.item.id)
                emit('deleted')
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При удалении типа договора произошла ошибка',
                })
            } finally {
                state.is_deleting = false
            }
        }

        const updateContractType = () => {
            if (!havePermissions(['contract-type-update', 'all-root-permission'])) {
                return
            }

            emit('update', { ...props.item })
        }

        return { state, havePermissions, deleteContractType, updateContractType }
    },
})
